import createIcon from '../../createIcon';

/**
 * @component @name FileDownloadOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS43MDk2MSA1LjQ1OTYxVjIuMjg5NjFIMTUuNzA5NlY4LjI4OTYxSDE5LjcwOTZMMTYuMTE5NiAxMS44Nzk2TDkuNzA5NjEgNS40NTk2MVpNMjEuODk5NiAyMC40Nzk2TDMuNTE5NjEgMi4wOTk2MUwyLjA5OTYxIDMuNTA5NjFMNi44Nzk2MSA4LjI4OTYxSDUuNzA5NjFMMTIuNzA5NiAxNS4yODk2TDEzLjI5OTYgMTQuNjk5NkwxNS44Nzk2IDE3LjI4OTZINS43MDk2MVYxOS4yODk2SDE3Ljg3OTZMMjAuNDg5NiAyMS44OTk2TDIxLjg5OTYgMjAuNDc5NloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileDownloadOff = createIcon('FileDownloadOff', [
  [
    'path',
    {
      d: 'M9.70961 5.45961V2.28961H15.7096V8.28961H19.7096L16.1196 11.8796L9.70961 5.45961ZM21.8996 20.4796L3.51961 2.09961L2.09961 3.50961L6.87961 8.28961H5.70961L12.7096 15.2896L13.2996 14.6996L15.8796 17.2896H5.70961V19.2896H17.8796L20.4896 21.8996L21.8996 20.4796Z',
      key: 'uspu6v',
    },
  ],
]);

export default FileDownloadOff;
